import React, { Component } from 'react';

import { Form, Icon, Popup } from 'semantic-ui-react';

import * as validationHelper from '../../../helpers/validationHelper';

import { FIELD_INVALID } from '../../../constants/errorMessages';

class FieldWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      applyValidation: false
    }
  }

  onBlur = () => {
    this.setState(({
      applyValidation: true
    }));

    if (this.props.onBlur) {
      this.props.onBlur();
    }
  }

  isError = () => {
    const { value, error, validation, justifyNullValues } = this.props;
    if (justifyNullValues && value == null) {
      return false;
    }
    const validationError = validation && !validationHelper.isValid(validation, value);
    return this.state.applyValidation && (validationError || error);
  }

  render() {
    const { label, required, popup, inputSub, errorMessage, validation, value, width, errorComponent, className } = this.props;
    const isError = this.isError();
    const isRequired = required || (validation && validation.required);

    return (
      <Form.Field
        className={className}
        error={isError}
        required={isRequired}
        width={width}
        onBlur={this.onBlur}>
        {label &&
          <label className={popup && "info-included"}>
            {label}
            {
              popup &&
              <Popup trigger={<Icon name="info circle" className="info-popup" />} size="mini" position="top right" basic content={popup} />
            }
          </label>
        }
        {this.props.children}
        {
          isError && errorComponent &&
          <div className="c-error">{errorComponent}</div>
        }
        {
          isError && !errorComponent &&
          <p className="c-error">{validationHelper.getValidationErrorMessage(validation, value) || errorMessage || FIELD_INVALID}</p>
        }
        {
          inputSub &&
          <div className="input-sub">{inputSub}</div>
        }
      </Form.Field>
    );
  }
}

export default FieldWrapper;
